import React, {Component} from 'react'
import PropTypes from 'prop-types'
import TableHead from "./data/TableHead"
import TableBody from "./data/TableBody"

class SkuTable extends Component {
    render() {
        const {products, loading, error, onRefresh, selectAll, arrSelected, onCheckALl, onSelected} = this.props

        return (
            <div className="SkuTable">
                <table className="table table-striped">
                    <TableHead
                        selectAll={selectAll}
                        onCheckALl={onCheckALl}
                        arrSelected={arrSelected}
                        onRefresh={onRefresh}
                    />
                    <TableBody
                        products={products}
                        loading={loading}
                        error={error}
                        onRefresh={onRefresh}
                        arrSelected={arrSelected}
                        onSelected={onSelected}
                    />
                </table>
            </div>
        )
    }
}

SkuTable.propTypes = {
    selectAll: PropTypes.bool,
    onCheckALl: PropTypes.func,
    products: PropTypes.array,
    loading: PropTypes.bool,
    error: PropTypes.string
}

export default SkuTable